import React from 'react'
import Subtitle from '../components/UI/Subtitle'
import PrivateMenu from '../components/Navigation/DashboardLinks';
import DashboardLinks from '../components/Navigation/DashboardLinks';
const Home = () => {

  return (
    <>
    <DashboardLinks />
    <div className="p-4">
    <Subtitle>Home:</Subtitle>
    <hr className='mt-4 mb-4'></hr>
    </div>
    </>
  )
}

export default Home